import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Panel } from "react-bootstrap";
import classNames from "classnames";
import { isEqual } from "@utils/lodash";

class CollapsiblePanel extends Component {
	shouldComponentUpdate({ children, expanded, verified }) {
		const lastProps = this.props;

		return (
			!isEqual(children, lastProps.children) ||
			!isEqual(expanded, lastProps.expanded) ||
			!isEqual(verified, lastProps.verified)
		);
	}

	handleLinkAction = e => {
		e.preventDefault();
		e.stopPropagation();

		const { linkAction } = this.props;
		linkAction();
	};

	render() {
		const {
			className,
			headerClassName,
			bodyClassName,
			title,
			subTitle,
			expanded,
			verified,
			handleToggle,
			link,
			footer,
			children,
			showArrow,
			dataTestId,
		} = this.props;

		return (
			<div data-test-id={dataTestId}>
				<Panel
					expanded={expanded}
					className={classNames("simple-collapse", className)}
					onToggle={handleToggle}
				>
					<Panel.Heading
						className={classNames(
							headerClassName,
							expanded ? "panel-expanded" : "panel-collapsed",
						)}
					>
						<Panel.Title toggle>
							<div className="title-content">
								<div className="title-check-icon">
									<If condition={verified}>
										<i className="rkf rkf-check-mark-o" />
									</If>
								</div>
								<div className="title-text">
									<div className="main-title">{title}</div>
									<div className="sub-title">{subTitle}</div>
								</div>
								<If condition={link !== ""}>
									<div className="margin-left-10">
										<Button
											bsStyle="link"
											className="btn-blue-small"
											onClick={this.handleLinkAction}
										>
											{link}
										</Button>
									</div>
								</If>
								<If condition={showArrow}>
									<div
										className={classNames(
											"margin-left-20 title-expand-icon",
											expanded ? "panel-expanded" : "panel-collapsed",
										)}
									>
										<i className="rkf rkf-chevron-up" />
									</div>
								</If>
							</div>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body className={bodyClassName}>{children}</Panel.Body>
						<If condition={footer}>
							<Panel.Footer>{footer}</Panel.Footer>
						</If>
					</Panel.Collapse>
				</Panel>
			</div>
		);
	}
}

CollapsiblePanel.propTypes = {
	title: PropTypes.string.isRequired,
	expanded: PropTypes.bool.isRequired,
	handleToggle: PropTypes.func.isRequired,
	className: PropTypes.string,
	headerClassName: PropTypes.string,
	bodyClassName: PropTypes.string,
	subTitle: PropTypes.string,
	verified: PropTypes.bool,
	link: PropTypes.string,
	linkAction: PropTypes.func,
	footer: PropTypes.element,
	children: PropTypes.any.isRequired,
	showArrow: PropTypes.bool,
	dataTestId: PropTypes.string,
};

CollapsiblePanel.defaultProps = {
	className: "",
	headerClassName: "",
	bodyClassName: "",
	subTitle: "",
	verified: false,
	link: "",
	linkAction: () => {},
	footer: undefined,
	showArrow: true,
	dataTestId: undefined,
};

export default CollapsiblePanel;
